import { wealthProApi } from "../../redux/api";

const clientFeeAgreementApiEndpoints = wealthProApi
    .injectEndpoints({
        endpoints: (builder) => ({
            previewClientFeeAgreement: builder.query({
                query: ({ masterAccountId }) => ({
                    url: `api/review/ClientFeeAgreements/clientconsent/preview/${masterAccountId}`,
                    method: 'GET',
                }),
                async onQueryStarted({ masterAccountId }, { dispatch, queryFulfilled }) {
                    try {
                        await queryFulfilled;
                        dispatch(wealthProApi.util.updateQueryData('fetchClientServiceTerms', { masterAccountId }, (data) => {
                            data = {...data, termsHaveBeenPreviewed: true};
                            return data;
                        }));
                    }
                    catch { }
                }
            }),
            publishClientFeeAgreement: builder.mutation({
                query: ({ masterAccountId }) => ({
                    url: `api/review/clientfeeagreements/clientconsent/publish/${masterAccountId}`,
                    method: 'GET',
                    responseType: 'blob' //Force to receive data in a Blob Format
                }),
                invalidatesTags: ["clientServiceTerms"]
            }),
            deleteClientFeeAgreement: builder.mutation({
                query: ({ clientFeeAgreementId }) => ({
                    url: `api/review/clientfeeagreements/${clientFeeAgreementId}`,
                    method: 'DELETE'
                }),
                async onQueryStarted({ clientFeeAgreementId, masterAccountId }, { dispatch, queryFulfilled }) {
                    try {
                        await queryFulfilled;
                        dispatch(wealthProApi.util.updateQueryData('fetchClientServiceTerms', { masterAccountId }, (data) => {
                            data.feeAgreements = data.feeAgreements.filter(el => el.clientFeeAgreementId !== clientFeeAgreementId);
                            return data;
                        }));
                    }
                    catch { }
                },
                invalidatesTags: ["clientServiceTerms"]
            }),
            patchClientFeeAgreement: builder.mutation({
                query: ({ clientFeeAgreementId, masterAccountId, operations }) => ({
                    url: `api/review/clientfeeagreements/${clientFeeAgreementId}`,
                    method: 'PATCH',
                    body: operations
                }),
                invalidatesTags: ["clientServiceTerms"]
            }),
            uploadEvidence: builder.mutation({
                query: ({data}) => ({
                    url: `api/review/clientfeeagreements/evidence/upload`,
                    method: 'POST',
                    body: data
                }),
                invalidatesTags: ["clientServiceTerms"]
            })
        }),
    });

export const {
    useLazyPreviewClientFeeAgreementQuery,
    usePublishClientFeeAgreementMutation,
    useDeleteClientFeeAgreementMutation,
    usePatchClientFeeAgreementMutation,
    useUploadEvidenceMutation
} = clientFeeAgreementApiEndpoints;
